/* eslint-disable */

export const ReportNames =  {
    BOM: "BOM",
    TAB_PREFIX: "NCAS Reporting",
    BUSINESS_CASE_COMPARISON: "Business Case Comparison",
    SALEABLE_COMPARISON: "Saleable Comparison",
    COMPONENT_WALK: "Component Walk",
    ECR_SUMMARY: "ECR Summary",
    CALCULATION_RESULTS: "Calculation Results",
    PROFIT_AND_LOSS: "Profit And Loss",
    FINANCIAL_DASHBOARD: "Financial Dashboard",
    ME_COST: "ME Cost",
    GSM: "GSM"
}

export const DialogMessages = {
    PLEASE_WAIT: "Depending on the size of the selected Business Case this may take awhile. Please Wait",
    ERROR: "Please try again. If issues persist please contact a system administrator"
}

export const Routes = {
    EXPORT_UNFORMATTED: "/export/excel/unformatted",
    EXPORT_FORMATTED: "/export/excel",
    SALEABLE_COMPARISON: "/compare/saleable",
    BUSINESS_CASE_COMPARISON: "/compare/businesscase",
    COMPONENT_WALK: "/walk/component",
    PROFIT_AND_LOSS_COMPARISON: "/compare/profitAndLoss",
}

export const EcrPickerLevels = {
    COST_STUDIES: "Cost Studies",
    VERSIONS: "Versions",
    SNAPSHOTS: "Snapshots",
    SALEABLE_PARTS: "Saleable Parts"
}

export const Currency = {
    USD: "USD"
}

export const GridArgumentNames = {
    VERSIONS: "Versions",
    OPTIONS: "Options",
    SALEABLE_PARTS: "SaleableParts",
    BUSINESS_CASE_COMPARISON: "BusinessCaseComparison",
    SALEABLE_COMPARISON: "SaleableComparison",
    COMPONENT_WALK: "ComponentWalk",
    BOM: "BOM",
    ECR_SUMMARY: "EcrSummary",
    CALCULATION_RESULTS: "CalculationResults",
    PROFIT_AND_LOSS: "ProfitAndLoss",
    FINANCIAL_DASHBOARD: "Financial Dashboard",
    GSM: "GSM",
    ME_COST: "MECost"
}

export const TabNames = {
    DEFAULT: "New Tab",
    BOM_COMPOSITE: "BOM (Composite)",
    BUSINESS_CASE_COMPARISON: "Business Case Comparison",
    CALCULATION_RESULTS: "Calculation Results",
    FX_RATES: "FX Rates",
    ME_CAPITAL: "ME Capital",
    ME_EXPENSE: "ME Expense",
    ME_PROCESS: "ME Process",
    ME_TOOLING: "ME Tooling",
    OTHER_COST: "Other Costs",
    PROTOTYPE: "Prototype",
    SALEABLE_COMPARISON: "Saleable Comparison",
    VENDOR_EXPENSE: "Vendor Expense",
    VENDOR_TOOLING: "Vendor Tooling",
    PROFIT_AND_LOSS: "Profit And Loss",
    FINANCIAL_DASHBOARD: "Financial Dashboard",
    MATERIAL_SQUEEZE: "Material Squeeze",
    GSM: "GSM",
    ME_COST: "ME Cost",
}

export const CalcualtionResultKeys = {
    TOTAL_REVENUE: "Total Revenue",
    GROSS_INVEST: "Gross Invest",
    TOOLING_REBILL: "Tooling Rebill",
    NET_INVEST: "Net Invest",
    NET_CAPEX: "Net CapEx",
    FORWARD_LEVERAGE: "Forward Leverage",
    OTHER_REVENUE: "Other Revenue",
    OPERATING_INCOME: "Operating Income",
    DISCOUNTED_CASH_FLOW: "Discounted Cash Flow",
    TAXABLE_INCOME: "Taxable Income",
    ENGINEERING: "Engineering",
    ENGINEERING_REBILL: "Engineering Rebill",
    FACTORY_COST: "Factory Cost",
    MATERIAL: "Material",
    MATERIAL_AND_FREIGHT_DUTY: "Material & Freight/Duty",
    INBOUND_FREIGHT: "Inbound Freight",
    INBOUND_DUTY: "Inbound Duty",
    OUTSIDE_PRODUCT_SALES: "Outside Product Sales",
    EXPENDABLE_PACKAGING_FOR_SALEABLE_PRODUCT: "Expendable Packaging for Saleable Product",
    DIRECT_LABOR: "Direct Labor",
    TOTAL_BURDEN_WO_DIRECT_LABOR: "Total Burden (w/o Direct Labor)",
    MISCELLANEOUS_MANUFACTURING_PIECE_COST: "Miscellaneous Manufacturing Piece Cost",
    CASH_FLOW_FROM_OPERATIONS: "Cash Flows from Operations",
    REACH: "Reach",
    NET_CASH_FLOW: "Net Cash Flow",
    MATERIAL_APRS: "MaterialAPRs",
    NCPS: "NCPs",
    APRS: "APRs",
    VALUE_SCOPE_GLOBAL_PREFIX: "Global",
    BUILDING_CAPITAL: "BuildingCapital",
    QUALITY_CAPITAL: "QualityCapital",
    QUALITY_EXPENSE: "QualityExpense",
    QUALITY_TOOLING: "QualityTooling",
    REARRANGE_CAPITAL: "RearrangeCapital",
    REARRANGE_EXPENSE: "RearrangeExpense",
    REARRANGE_TOOLING: "RearrangeTooling",
    STARTUP_COSTS: "StartupCosts",
    VALIDATION_EQUIPMENT: "ValidationEquipment",
    OUTSIDE_MATERIAL: "Outside Material",
    FREIGHT: "Freight",
    PURCHASE_FREIGHT_COST: "Purchase Freight Cost",
    INTERPLANT_FREIGHT_COST: "Interplant Freight Cost",
    WAREHOUSING: "Warehousing",
    WAREHOUSE_COST: "Warehouse Cost",
    INTERPLANT_WAREHOUSE_COST: "Interplant Warehouse Cost",
    PACKAGING: "Packaging",
    PACKAGING_COST: "Packaging Cost",
    INTERPLANT_PACKAGIING_COST: "Interplant Packaging Cost",
    EXPENDABLE_DUNNAGE: "ExpendableDunnage",
    OUTBOUND_FREIGHT_COST: "Outbound Freight Cost",
    OUTBOUND_WAREHOUSE_COST: "Outbound Warehouse Cost",
    OUTBOUND_PACKAGING_COST: "Outbound Packaging Cost",
    OUTBOUND_FREIGHT: "Outbound Freight",
    OTHER_COGS: "Other COGS",
    OUTBOUND_DUTY_AFTER_DRAWBACK: "Outbound Duty After Drawback",
    VARIABLE_MANUFACTURING: "Variable Manufacturing",
    FIXED_MANUFACTURING: "Fixed Manufacturing",
    OPERATIONS_EXPENSE: "Operations Expense",
    STARTUP_LAUNCH_COST: "Startup/Launch Cost",
    OTHER_INCREMENTAL_COST_PER_UNIT: "Other Incremental Cost (per unit)",
    WARRANTY_COST: "Warranty Cost",
    OCOGS: "OCOGS",
    COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION: "Cost of Sales Depreciation & Amortization",
    MANUFACTURING_DEPRECIATION_CURRENT: "Manufacturing Depreciation - Current",
    NEW_MANUFACTURING_DEPRECIATION: "New Manufacturing Depreciation",
    AMORTIZATION: "Amortization",
    SG_AND_A: "SG&A",
    PRORATED_CAPITAL: "Prorated Capital",
    MANUFACTURING_NON_REBILL_TOOLING: "Manufacturing Non-Rebill Tooling",
    VENDOR_NON_REBILL_TOOLING: "Vendor Non-Rebill Tooling",
    MANUFACTURING_REBILL_TOOLING: "Manufacturing Rebill Tooling",
    VENDOR_REBILL_TOOLING: "Vendor Rebill Tooling",
    EXPENSE_INVESTMENTS: "Expense Investments",
    PROTOTYPE_SALES: "Prototype Sales",
    TOOLING_REBILL_REVENUE: "Tooling Rebill Revenue",
    OTHER_INCREMENTAL_COST: "Other Incremental Cost",
    TOOLING_REBILL_EXPENSE: "Tooling Rebill Expense",
    FACTORY_PROFIT: "Factory Profit",
    SPECIAL_TOOLING_AMORTIZATION: "Special Tooling Amortization",
    APPLICATION_ENGINEERING_AMORTIZATION: "Application Engineering Amortization",
    GROSS_PROFIT: "Gross Profit",
    OTHER_OPERATING_EXPENSES: "Other Operating Expenses",
    RESEARCH_ENGINEERING: "Research Engineering",
    ROYALTY_EXPENSE: "Royalty Expense",
    PURSUIT_AND_CI_ENGINEERING: "Pursuit & CI Engineering",
    BANK_NOTE_DISCOUNTING_EXPENSE: "Bank Note Discounting Expense",
    ADDITIONAL_CONTINUOUS_IMPROVEMENT: "Additional Continuous Improvement",
    CONTINUOUS_IMPROVEMENT_DEFAULT: "Continuous Improvement (default)",
    CAPITAL_INVESTMENTS: "Capital Investments",
    TOOLING_INVESTMENTS: "Tooling Investments",
    GROSS_INVEST: "Gross Invest",
    MANUFACTURING_TOOLING_REBILL_ELIGIBLE: 'Manufacturing Tooling (Rebill Eligible)',
    VENDOR_TOOLING_REBILL_ELIGIBLE: 'Vendor Tooling (Rebill Eligible)',
    VENDOR_TOOLING_NON_REBILL: 'Vendor Tooling (Non-Rebill)',
    MANUFACTURING: "Manufacturing",
    MANUFACTURING_ADJUSTMENT: "Manufacturing Adjustment",
    MANUFACTURING_COST: "Manufacturing Cost"

}

export const ColumnHeaders = {
    APRs: "APRs",
    AVG_MATERIAL_PER_PC: "Avg Material per Pc",
    AVG_SALES_PRICE_PER_PC: "Avg Sales Price per Pc",
    BOM_LEVEL: "BOM Lev",
    BURDEN_CENTER: "Burden Center",
    BUSINESS_CASE_FLOOR_ADJUSTMENT: "Business Case Floor Adjustment",
    BUSINESS_CASE_FLOOR_PRICE: "Business Case Floor Price",
    CALCULATED_STD_HOURS: "Calculated Std Hours",
    CALCULATION_ID: "Calculation Id",
    CAPITAL: "Capital (applied to BC)",
    CAPITAL_INVERSTMENT_POWER_CONSUMPTION: "Capital Investment Power Consumption",
    CAPITAL_INVESTMENT_DESCRIPTION: "Capital Investment Description",
    CAPITAL_INVESTMENT_FLOOR_SPACE_SQ_M: "Capital Investment Floor Space Sq M",
    CAPITAL_INVESTMENT_PRORATE_ELIGIBLE_PERCENT: "Capital Investment Prorate Eligible Percent",
    CAPITAL_INVESTMENT_QTY: "Capital Investment Quantity",
    CAPITAL_INVESTMENT_RETOOL_TAG_NUMBER: "Capital Investment Retool Tag Number",
    COMPONENT_NAME: "Component Name",
    COMPONENT_PART_NUMBER: "Component Part Number",
    COMPONENT_PART_REV: "Component Part Revision",
    COMPONENT_PART_SUFFIX: "Component Part Suffix",
    CONVERTED_PREFIX: "(Converted)",
    COST_STUDY: "Cost Study",
    COST_TYPE: "Cost Type",
    CREW_SIZE: "Crew Size",
    CURRENCY_PREFIX: "Currency",
    CURRENT_DEPRECIATION: "Current Depreciation",
    CUSTOMER_SALEABLE_PART_NUMBER: "Customer Saleable Part Number",
    CYCLE_TIME: "Cycle Time",
    DEPRECIATION: "Depreciation",
    DIRECT_LABOR_YEAR_ONE: "Direct Labor - Year 1",
    DIVISION: "Division",
    DSS_INCLUDED: "DSS Included",
    DUTY_COST_PER_ASM: "Duty Cost per Asm",
    DUTY_DRAWBACK_PERCENT: "Duty Drawback Percent",
    DUTY_INBOUND_YEAR_ONE: "Duty (inbound) - Year 1",
    DUTY_OUTBOUND_YEAR_ONE: "Duty (outbound) - Year 1",
    DUTY_PERCENT: "Duty Percent",
    ECR_NUMBER: "ECR Number",
    ED_AND_T: "ED&T $000",
    ED_AND_T_REBILL: "ED&T Rebill $000",
    EFFICIENCY: "Efficiency",
    ENGINEERING_TAX: "Engineering (incl Research \"Tax\")",
    ENTITY: "Entity",
    EXISITING_MACHINES: "Existing Machines",
    EXPENDABLE_DUNNAGE: "Expendable Dunnage",
    EXPENDABLE_DUNNAGE_PER_ASM: "Expendable Dunnage per Asm",
    EXPENDABLE_DUNNAGE_YEAR_ONE: "Expendable Dunnage - Year 1",
    EXPENSE: "Expense",
    EXPENSE_INVESTMENT_DESCRIPTION: "Expense Investment Description",
    EXPENSE_INVESTMENT_QTY: "Expense Investment Quantity",
    EXPORT_READY: "Export Ready",
    FIXED_BURDEN: "Fixed Burden",
    FREIGHT_COST: "Freight Cost",
    FREIGHT_COST_PER_ASM: "Freight Cost per Asm",
    FREIGHT_WAREHOUSE_YEAR_ONE: "Freight / Warehouse (outbound) - Year 1",
    FREIGHT_YEAR_ONE: "Freight (inbound) - Year 1",
    FWL: "FWL $000",
    GrossInvst: "Gross Invst $000",
    INCOTERMS: "Incoterms",
    INVENTORY_DAYS: "Inventory Days",
    INVESTMENT: "Investment (Display Currency)",
    IRR: "IRR %",
    IS_INITIAL: "Is Initial",
    LABOR_IN_OPERATION: "Labor In Operation",
    LEAD_TIME_WEEKS: "Lead Time Weeks",
    LIFETIME_BUISINESS_VOLUME: "Lifetime Business Volume",
    LINE_ITEM_LABEL: "Line Item Label",
    LINKED_OPERATION: "Linked Operation",
    LOGISTICS_COMMENTS: "Logistics Comments",
    LOGISTICS_LOCATION: "Logistics Location",
    LOGISTICS_TOTAL_USAGE_VOLUME_PREFIX: "LC Total Usage Volume",
    LOGISTICS_VOLUME_ALLOCTION_SHARE: "Logistics Volume Allocation Share",
    LTR: "Lifetime Revenue (LTR)",
    LTV: "Lifetime Volume (LTV)",
    MAINTAIN_FOR_SERVICE: "Maintain For Service",
    MATERIAL_COST: "Material Cost",
    MATERIAL_COST_PER_ASM: "Material Cost per Asm",
    MATERIAL_MASS: "Material Mass",
    MATERIAL_MASS_UOM: "Material Mass UoM",
    MATERIAL_TO_SALES: "Material to Sales",
    MATERIAL_TYPE: "Material Type",
    MATERIAL_YEAR_ONE: "Material - Year 1",
    MFG_COMMENTS: "Mfg Comments",
    MFG_NON_REBILL_TOOLING: "Mfg. Non - Rebill Tooling",
    MFG_PLANT: "Mfg Plant",
    MFG_PRO_NAME: "Mfg Pro Name",
    MFG_RATE_TO_SALES: "Mfg Rate to Sales",
    MFG_REBILL_ELIGIBLE_TOOLING: "Mfg. Rebill - Eligible Tooling",
    MFG_VOLUME_ALLOCATION_SHARE: "Mfg Volume Allocation Share",
    MFG_VOLUME_ALLOCATION_SHARE_PROCESS_NAME: "Mfg Volume Allocation Share Process Name",
    MISC_PIECE_COST: "Misc Piece Cost",
    NCPs: "NCPs",
    NESTED: "Nested",
    NET_ED_AND_T: "Net ED&T $000",
    NEW_MACHINES: "New Machines",
    NPV: "NPV $000",
    NetCapital: "Net Capital",
    NetInvst: "Net Invst $000",
    OCOGS: "OCOGS",
    OIAmount: "OI Amount",
    OIPercent: "OI %",
    OPERATIONS_EXPENSE: "Operations Expense",
    OPERATION_DESCRIPTION: "Operation Description",
    OPERATION_NUMBER: "Operation Number",
    OPTION_NAME: "Option Name",
    OTHER_COST_DESCRIPTION: "Other Cost Description",
    OTHER_INCREMENTAL_COST: "Other Incremental (Includes Reach)",
    PACKAGING_COST: "Packaging Cost",
    PACKAGING_COST_PER_ASM: "Packaging Cost per Asm",
    PACKAGING_TYPE: "Packaging Type",
    PEAK_ANNUAL_VOLUME: "Peak Annual Volume",
    PLANT: "Plant",
    PLANT_NUMBER: "Plant Number",
    PRICE_BREAKDOWN: "Price Breakdown (Display Currency / pc)",
    PROCESS_TYPE: "Process Type",
    PRODCUT_ENGINEER_COMMENTS: "Product Engineer Comments",
    PRODUCTION_METHOD: "Prod Method",
    PRODUCT_GROUP: "Product Group",
    PROFIT: "Profit",
    PROTOTYPE_DESCRIPTION: "Prototype Description",
    PURCHASE_DATA_TYPE: "Purchase Data Type",
    PURCHASING_COMMENTS: "Purchasing Comments",
    QTY_PER_PARENT: "Quantity Per Parent",
    QTY_PER_SALEABLE: "Quantity Per Saleable",
    REACH: "Reach",
    REACH_ASSUMPTIONS: "Reach Assumptions",
    RECV_PLANT: "Recv Plant",
    RETURNABLE_DUNNAGE_INVESTMENT_PREFIX: "Returnable Dunnage Investment",
    RUN_TIME_PER_THREE_SHIFTS: "Run Time Per Three Shifts",
    Rebill: "Rebill $000",
    SALEABLE_PART_NUMBER: "Saleable Part Number",
    SALEABLE_PART_REV: "Saleable Part Rev",
    SALEABLE_PART_SUFFIX: "Saleable Part Suffix",
    SG_AND_A: "SG & A",
    SORT_ORDER: "Sort Order",
    SOURCING_RISK: "SourcingRisk",
    STARTUP: "Startup",
    START_YEAR: "Start Year",
    SUPPLIER_LOCATION: "Supplier Location",
    SUPPLIER_NAME: "Supplier Name",
    TITLE_TRANSFER_TERMS: "Title Transfer Terms",
    TOOLING_AMORTIZATION: "Tooling Amortization",
    TOOLING_CURRENCY: "Tooling Currency",
    TOOLING_INVESTMENT_DESCRIPTION: "Tooling Investment Description",
    TOOLING_INVESTMENT_ELECTED_REBILL_PERCENT: "Tooling Investment Elected Rebill Percent",
    TOOLING_INVESTMENT_IS_REBILLABLE: "Tooling Investment Is Rebillable",
    TOOLING_INVESTMENT_QTY: "Tooling Investment Quantity",
    TOOLING_INVESTMENT_TOOL_LIFE_PCS: "Tooling Investment Tool Life Pcs",
    TOOLING_INVESTMENT_TOOL_REPLACEMENT_COST: "Tooling Investment Tool Replacement Cost",
    TOOLING_REBILL: "Tooling Rebill",
    TOTAL_AMOUNT: "Total Amount",
    TOTAL_CAPITAL_INVESTMENT_COST: "Total Capital Investment Cost",
    TOTAL_COST: "Total Cost",
    TOTAL_EXPENSE_INVESTMENT_COST: "Total Expense Investment Cost",
    TOTAL_RETURNABLE_DUNNAGE_INVESTMENT: "Total Returnable Dunnage Investment",
    TOTAL_TOOLING_INVESTMENT_COST: "Total Tooling Investment Cost",
    TOTAL_TOOLING_REBILL: "Total Tooling Rebill",
    UNIT_COST: "Unit Cost",
    UNIT_PRICE: "Unit Price",
    UOM: "UoM",
    VALUE_SCOPE: "Value Scope",
    VARIABLE_BURDEN: "Variable Burden",
    VENDOR_EXPENSE_DESCRIPTION: "Vendor Expense Description",
    VENDOR_EXPENSE_CURRENCY: "Vendor Expense Currency",
    VENDOR_EXPENSE: "Vendor Expense",
    VENDOR_NON_REBILL_TOOLING: "Vendor Non - Rebill Tooling",
    VENDOR_REBILL_ELIGIBLE_TOOLING: "Vendor Rebill - Eligible Tooling",
    VENDOR_TOOL_DESCRIPTION: "Vendor Tool Description",
    VENDOR_TOOL_ELECTED_REBILL_PERCENT: "Vendor Tool Elected Rebill Percent",
    VENDOR_TOOL_IS_REBILLABLE: "Vendor Tool Is Rebillable",
    VERSION: "Version",
    VERSION_ID: "Version Id",
    VOLUME_ALLOCATED_TOTAL_RETURNABLE_DUNNAGE_INVESTMENT: "Volume Allocated Total Returnable Dunnage Investment",
    WAREHOUSE_COST: "Warehouse Cost",
    WAREHOUSE_COST_PER_ASM: "Warehouse Cost per Asm",
    WARRANTY: "Warranty",
    WORKING_DAYS_PER_YEAR: "Working Days Per Year",
    YEAR_ONE_BUISINESS_VOLUME: "Year 1 Business Volume",
    VOLUME_K: "Volume (K)",
    TOTAL_REVENUE: "Total Revenue",
    OUTSIDE_PRODUCT_SALES: "Outside Product Sales",
    PROTOTYPE_SALES: "Prototype Sales",
    ENGINEERING_REBILL: "Engineering Rebill",
    FORWARD_LEVERAGE: "Forward Leverage",
    FACTORY_COST: "Factory Cost",
    OUTSIDE_MATERIAL_INC_ALLIED: "Outside Material (including Allied Mat)",
    INBOUND_FREIGHT: "Inbound Freight",
    INBOUND_DUTY: "Inbound Duty",
    EXPENDABLE_PACKAGING_FOR_SALEABLE_PRODUCT: "Expendable Packaging (for saleable product)",
    DIRECT_LABOR: "Direct Labor",
    MANUFACTURING_COST_EXCLUDING_CURRENT_DEPRECIATION: "Manufacturing cost (excluding current depreciation)",
    START_UP_LAUNCH_COST: "Start - up / Launch cost",
    OPERATION_EXPENSES: "Operation expenses",
    PROFIT_LOSS_OTHER_INCREMENTAL_COST: "Other incremental cost",
    TOOLING_REBILL_EXPENSE: "Tooling Rebill expense",
    FACTORY_PROFIT: "Factory Profit",
    FACTORY_MARGIN: "Factory Margin",
    OTHER_OCOGS: "OCOGS",
    OUTBOUND_FREIGHT: "Outbound Freight",
    COST_OF_SALES_DEPRECIATION_AND_AMORTIZATION: "Cost of Sales Depreciation & Amortization",
    MANUFACTURING_DEPRECIATION_CURRENT: "Manufacturing Depreciation - current",
    NEW_MANUFACTURING_DEPRECIATION: "New Manufacturing Depreciation",
    SPECIAL_TOOLING_AMORTIZATION: "Special Tooling Amortization",
    APPLICATION_ENGINEERING_AMORTIZATION: "Application Engineering Amortization",
    GROSS_PROFIT: "Gross Profit",
    GROSS_MARGIN: "Gross Margin",
    OTHER_OPERATING_EXPENSES: "Other Operating Expenses",
    RESEARCH_ENGINEERING: "Research Engineering",
    ROYALTY_EXPENSE: "Royalty expense",
    PURSUIT_AND_CI_ENGINEERING: "Pursuit & CI Engineering",
    OTHER_COST_TIE_OUT: "Other costs tie out",
    BANK_NOTE_DISCOUNTING_EXPENSE: "Bank Note Discounting Expense",
    OPERATING_INCOME: "Operating Income",
    OPERATING_MARGIN: "Operating Margin",
    NPV_K: "NPV (k)",
    OTHER_REVENUE: "Other Revenue",
    MANUFACTURING_ADJUSTMENT: "Manufacturing Adjustment"


}